import { useEffect, useState } from 'react'
import Modal from '../Modal/Modal'

const EntertainmentModal = () => {

	const [showModal, setShowModal] = useState(true)

	const handleModal = () => {
		setShowModal(false)
	}

	useEffect(() => {
		if (showModal) {
			document.body.classList.add('modal-open')
		} else {
			document.body.classList.remove('modal-open')
		}
	}, [showModal])

	if (showModal) 
		return (

			<Modal
				showModal={showModal}
				handleModal={handleModal}
				title="Entertainment Eve Tickets"
				actionButtonText="Buy Tickets"
				actionButtonLink="https://www.festivelabs.com/"
			>
				<img
					src='/assets/concert.webp'
					alt='concert'
					className='w-full'
				/>
			</Modal>
		)
	else return null

}

export default EntertainmentModal